import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { IonContent, Platform } from '@ionic/angular';
import { GlobalDataService } from 'src/app/services/global-data.service';
import { JsonLdService } from 'src/app/services/json-ld.service';
import { SeoService } from 'src/app/services/seo.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.page.html',
  styleUrls: ['./sitemap.page.scss'],
})
export class SitemapPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;

  cordova: boolean = false;
  isBrowser: boolean = false;
  showToolbar: boolean = false;
  pages = [];
  title: string = `User Sitemap | HTML Sitemap | ${
    environment.environment_title
  } ${environment.environment_name == 'clearwater' ? '' : 'Shopping Centre'}`;
  excerpt: string = `By visiting our User/HTML Sitemap you can find all of the important pages on the ${environment.environment_title} website with a singular click.`;
  featuredImage: string =
    'https://cdn.hyprop.co.za/image/2021/8/29/7fddb280-071b-4634-a22b-86a8ddce6b88/8b4eeed0-5535-40ae-92e5-9c8326fb36aa.jpg';

  constructor(
    private platform: Platform,
    private seo: SeoService,
    private router: Router,
    private jsonLdService: JsonLdService,
    private globalData: GlobalDataService,
    @Inject(PLATFORM_ID) private platformId
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.globalData.dataChange.subscribe((value) => {
      this.updateGlobalData(value);
    });

    this.platform.ready().then(() => {
      this.cordova = this.platform.is('cordova');
    });
  }

  /**
   * Link to detail page dependant on content type
   */
  linkToPage(item) {
    let url = item.path;

    if (url.indexOf('/') < 0) url = '/page/' + item.path;

    // if (item.newWindow && window !== undefined) {
    //   window.open(url, "_blank");
    // } else {
    this.router.navigateByUrl(url);
    // }
  }

  /**
   * Update data when global data changes
   * Set links for all pages based on header & footer menus
   */
  updateGlobalData(data) {
    if (data.menus?.header) this.pages = this.pages.concat(data.menus.header);

    if (data.menus?.footer) {
      data.menus.footer.forEach((group) => {
        if (!group.title.toLowerCase().includes('newsletter'))
          this.pages.push(group);
      });
    }
  }

  /**
   * Change header background color when scrolling
   */
  onScroll($event: CustomEvent) {
    if (this.isBrowser && $event && $event.detail && $event.detail.scrollTop) {
      const scrollTop = $event.detail.scrollTop;
      this.showToolbar = scrollTop >= 160;
    }
  }

  ngOnInit() {
    const initialMallData = this.globalData.getGlobalData();
    if (initialMallData) this.updateGlobalData(initialMallData);

    if (!this.cordova) {
      let schemaData = {};

      // Title tag
      this.seo.setTitle(this.title);
      schemaData = {
        ...schemaData,
        name: this.title,
      };

      // Description tag
      const seoData = {
        title: this.title,
        description: this.excerpt,
        keywords: initialMallData.general.metaKeywords + ' stores',
        socialImage: this.featuredImage,
      };
      this.seo.setMeta(seoData);
      this.seo.setSEOMeta(seoData);
      schemaData = {
        ...schemaData,
        description: this.excerpt,
      };

      this.jsonLdService.insertSchema(schemaData);
    }
  }

  ionViewWillEnter() {
    this.content.scrollToTop();
    this.showToolbar = false;
  }
}
